import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { getAlarms, createAlarm, deleteAlarm } from '../api/boardAlarm.api';
import { IAlarm, IGetAlarms, IAlarmReq } from '../models/boardAlarm.model';

interface IAlarmState {
  alarms: IAlarm[];
  isLoading: boolean;
  error?: AxiosError | string;
};

const initialState: IAlarmState = {
  alarms: [],
  isLoading: false
};

const alarmSlicer = createSlice({
  name: 'alarm',
  initialState,
  reducers: {
    getAlarmsStart: (state: IAlarmState) => {
      state.alarms = [];
      state.isLoading = true;
      state.error = undefined;
    },
    getAlarmsSuccess: (state: IAlarmState, action: PayloadAction<IGetAlarms>) => {
      state.alarms = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getAlarmsFailure: (state: IAlarmState, action: PayloadAction<AxiosError|string>) => {
      state.alarms = [];
      state.isLoading = false;
      state.error = action.payload;
    },
    requestStart: (state: IAlarmState) => {
      state.isLoading = true;
      state.error = undefined;
    },
    requestFailure: (state: IAlarmState, action: PayloadAction<AxiosError|string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    createSuccess: (state: IAlarmState) => {
      state.isLoading = false;
      state.error = undefined;
    },
    deleteSuccess: (state: IAlarmState) => {
      state.isLoading = false;
      state.error = undefined;
    },
  }
});

export const {
  getAlarmsStart,
  getAlarmsSuccess,
  getAlarmsFailure,
  requestStart,
  requestFailure,
  createSuccess,
  deleteSuccess
} = alarmSlicer.actions;

export default alarmSlicer.reducer;

// BR0007 = 게시판 알림 테이블
export const doGetAlarms = (BR0007: string, boardDiv: string): any => async (dispatch: any) => {
  try {
    dispatch(getAlarmsStart());
    const response = await getAlarms(BR0007, boardDiv);
    dispatch(getAlarmsSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getAlarmsFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doCreateAlarm = (BR0007: string, boardDiv: string, data: IAlarmReq): any => async (dispatch: any) => {
  try {
    dispatch(requestStart());
    const response = await createAlarm(BR0007, boardDiv, data);
    dispatch(createSuccess());
    return response;
  } catch (e: any) {
    dispatch(requestFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doDeleteAlarm = (alarmCode: number): any => async (dispatch: any) => {
  try {
    dispatch(requestStart());
    const response = await deleteAlarm(alarmCode);
    dispatch(deleteSuccess());
    return response;
  } catch (e: any) {
    dispatch(requestFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};
